<template>
  <p class="container txt-tit-desc">
      <slot />
  </p>
</template>

<script>
export default {
  name: 'PageSubTitle',
};
</script>

<style>

</style>
